import React from "react";

import LeftSection from "./LeftSection";

import {
  Wrapper,
  WrapperContainer,
  TwoColumnSection,
  LeftSectionWrapper,
  RightSectionWrapper,
} from "./style";

function HowItWorksSection({ data = {}, formRef, howItWorksRef, children }) {
  return (
    <Wrapper>
      <WrapperContainer>
        <TwoColumnSection>
          <LeftSectionWrapper ref={howItWorksRef}>
            <LeftSection data={data} />
          </LeftSectionWrapper>
          <RightSectionWrapper ref={formRef}>{children}</RightSectionWrapper>
        </TwoColumnSection>
      </WrapperContainer>
    </Wrapper>
  );
}

export default HowItWorksSection;
